export class KhachHang {
    MaKHTV: string;
    TenKH: string;
    Diem: string;
    MaCapDo: string;
    TenCapDo: string;
    TLCK?: number;
}


//<Không dùng
export class KHTV {
  id: string;
  name: string;
  type: string;
  typeName: string;
}
//Không dùng>

export class KH_HCG {
  id: string;
  name: string;
  type: string;
  typeName: string;
}



export class KHTV_SGC {
MaThe13        : string  
MaThe7         : string  
HoLot          : string  
Ten            : string  
TenQuanHuyen   : string  
DTDD           : string  
DTBan          : string  
MaCH_DangKy    : string  
Diem           : number 
MaCapDo        : string  
TenCapDo: string
}



// WEBPACK FOOTER //
// ./src/app/models/customer.model.ts